import type { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { listTags } from "../lib/posts";
import "./header-badges.css";

const badges: { label: string; color: string; icon: ReactNode }[] = [
  {
    label: "GitHub", color: "#c9d1e0",
    icon: <path fill="currentColor" d="M12 .9a11.1 11.1 0 0 0-3.5 21.6c.6.1.8-.2.8-.5v-2c-3.4.7-4.1-1.5-4.1-1.5-.5-1.4-1.3-1.7-1.3-1.7-1.1-.8.1-.8.1-.8 1.2.1 1.8 1.2 1.8 1.2 1 1.8 2.7 1.3 3.4 1 .1-.8.4-1.3.7-1.6-2.7-.3-5.5-1.4-5.5-6a4.7 4.7 0 0 1 1.2-3.2c-.1-.3-.5-1.6.1-3.3 0 0 1-.3 3.4 1.2a11.7 11.7 0 0 1 6.2 0c2.4-1.5 3.4-1.2 3.4-1.2.6 1.7.2 3 .1 3.3a4.7 4.7 0 0 1 1.2 3.2c0 4.6-2.8 5.7-5.5 6 .4.4.8 1.1.8 2.2V22c0 .3.2.6.8.5A11.1 11.1 0 0 0 12 .9Z" />
  },
  {
    label: "HTML", color: "#af79fb",
    icon: <><path fill="currentColor" d="m3 2 1.6 18L12 22l7.4-2L21 2H3Z" /><path fill="#111720" d="M7 6h10l-.2 2.4h-7l.2 2.3h6.6l-.6 6.7-4 1.1-4-1.1-.3-3.5h2.4l.1 1.7 1.8.5 1.8-.5.2-2.5H7.6L7 6Z" /></>
  },
  {
    label: "CSS", color: "#38aaf1",
    icon: <><path fill="currentColor" d="m3 2 1.6 18L12 22l7.4-2L21 2H3Z" /><path fill="#111720" d="M7 6h10l-.2 2.4-5.5 2.3h5.3l-.6 6.7-4 1.1-4-1.1-.3-3.5h2.4l.1 1.7 1.8.5 1.8-.5.2-2.5H7.6l-.2-2.4 5.5-2.3H7.2L7 6Z" /></>
  },
  {
    label: "JavaScript", color: "#eec551",
    icon: <><rect x="2" y="2" width="20" height="20" rx="2" fill="currentColor" /><path d="M12 8v9c0 3-5 3-5 0m7-1c1 3 5 3 5 .5 0-2-4.5-2-4.5-4.5s4.5-3 4.5-.5" stroke="#111720" strokeWidth="1.7" fill="none" /></>
  },
  {
    label: "React", color: "#40cbe8",
    icon: <><circle cx="12" cy="12" r="2.1" fill="currentColor" /><g stroke="currentColor" strokeWidth="1.2" fill="none"><ellipse cx="12" cy="12" rx="11" ry="4.2" /><ellipse cx="12" cy="12" rx="11" ry="4.2" transform="rotate(60 12 12)" /><ellipse cx="12" cy="12" rx="11" ry="4.2" transform="rotate(120 12 12)" /></g></>
  },
  {
    label: "Node.js", color: "#91c845",
    icon: <><path d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1Z" stroke="currentColor" strokeWidth="1.5" fill="none" /><path d="M10.5 7v9c0 2-3.5 2-3.5 0m6-1c1 2.5 4.5 2.5 4.5.5 0-2-4-2-4-4s4-2.5 4-.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none" /></>
  },
  {
    label: ".NET", color: "#8650e8",
    icon: <><rect x="1" y="1" width="22" height="22" rx="2" fill="currentColor" /><path d="M4 16h.1M7 16V8l4 8V8m3 0h3m-3 0v8h3m-3-4h2m2-4h4m-2 0v8" stroke="white" strokeWidth="1.15" strokeLinejoin="round" /></>
  }
];

export function TechBadges() {
  const { data: tags = [] } = useQuery({ queryKey: ["tags"], queryFn: listTags });
  return (
    <div className="tech-badges nm-tech-badges" aria-label="Technologies">
      {badges.map(({ label, color, icon }) => (
        <span className="badge nm-tech-badge" key={label}>
          {tags.find(t => t.name.toLowerCase() === label.toLowerCase())?.icon_url ? <img src={tags.find(t => t.name.toLowerCase() === label.toLowerCase())!.icon_url!} alt="" width={20} height={20} /> : <svg viewBox="0 0 24 24" style={{ color }} aria-hidden="true">{icon}</svg>}
          {label}
        </span>
      ))}
    </div>
  );
}
